const initialState = {
    noData: false,
    templatesList: [],
    fetching: false,
    fetched: false,
    error: null
}

export function templatesReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_TEMPLATES_LIST_TOKEN":
        case "FETCH_TEMPLATES_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }
        case "FETCH_TEMPLATES_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }
        case "FETCH_TEMPLATES_LIST_FULFILLED": {
            action.payload.data.sort(function (a, b) {
                if (a.published < b.published)
                    return 1
                else if (a.published > b.published)
                    return -1
                else if (a.priority < b.priority)
                    return -1
                else if (a.priority > b.priority)
                    return 1
                else if (a.name.toLowerCase() < b.name.toLowerCase())
                    return -1
                else if (a.name.toLowerCase() > b.name.toLowerCase())
                    return 1
                else 
                    return 0                   
            })

            return { ...state, fetching: false, fetched: true, noData: action.payload.data.length == 0, templatesList: action.payload.data }
        }
        case "FETCH_TEMPLATE_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        default:
            return state
    }
}